import React from 'react';

const SelectOptionsMessage = (props) => {
  return (
    <div className="d-flex flex-row annotation-select-field">
      <span>
        <div style={{"fontSize": "12px"}}>{props.label}</div>
          <select
            id="annotationSelect"
            className="n2-select"
            disabled={props.disabled}
            defaultValue={props.selectedOption}
          >
            {props.options.map((option, i) =>
              <option key={i} value={option}>{option}</option>
            )}
          </select>
          { !props.disabled &&
            <button className="btn btn-primary" onClick={() => props.handleSubmission(props.annotation, props.selectedOption)}>Submit</button>
          }
      </span>
    </div>
  );
};

export default SelectOptionsMessage;
